import select from "~/js/select";
import type { PageId } from "~/types";

class PageManager<PageName extends string = string> {
	#pages = {} as Record<PageName, HTMLElement>;
	currentPage: PageName;
	pageData: string | null = null;
	#defaultPage: PageName;
	constructor(defaultPage: PageName) {
		this.currentPage = defaultPage;
		this.#defaultPage = defaultPage;
	}
	makePage(pageName: PageName, root: HTMLElement) {
		this.#pages[pageName] = root;
		return root;
	}

	createPage(pageName: PageName, elements: HTMLElement[] = []) {
		const pageElement = q(".page", [...elements]);
		pageElement.setAttribute("page", pageName);
		this.#pages[pageName] = pageElement;
		return pageElement;
	}

	showPage(pageName: PageName, data?: string) {
		this.pageData = data || null;
		if (this.currentPage === pageName) return;
		this.currentPage = pageName;

		const pageRoot = this.#pages[pageName];
		select("#pages")!.innerHTML = "";
		if (pageRoot) {
			select("#pages")!.appendChild(pageRoot);
		} else {
			select("#pages")!.innerHTML = `<div class="page" page="${this.#defaultPage}">Page "${pageName}" not found.</div>`;
		}
	}
}

export const Pages = new PageManager<PageId>("welcome");
